<template>
  <div class="user-edit">
    <el-form ref="editForm" label-width="100px" :model="editJson" :rules="rules">
      <el-form-item label="姓名" prop="authorizedPersonNo">
        <selecter
          v-model="editJson.authorizedPersonNo"
          @selecterData="getSelecterWkNameData"
          :jobNo="editJson.authorizedPersonNo"
          :name="editJson.authorizedPersonName"
        ></selecter>
      </el-form-item>
      <el-form-item label="截止时间" prop="deadline">
        <el-date-picker value-format="yyyy-MM-dd" v-model="editJson.deadline" type="date" placeholder="选择日期"  :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>
      <el-form-item label="是否启用" prop="status">
        <el-switch v-model="editJson.status" :inactive-value="0" :active-value="1"></el-switch>
        &nbsp;&nbsp;{{ editJson.status == 1 ? '是' : '否' }}
      </el-form-item>
      <el-form-item label-width="0" class="atb-no-margin">
        <div class="atb-text-right">
          <!-- 保存 -->
          <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
          <!-- 取消 -->
          <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide()">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import editMixin from '@/mixins/edit.mixin';
import _ from 'lodash';
export default {
  components: {
    selecter: () => import('@/component/global/customerSelect'),
  },
  mixins: [editMixin],
  props: {
    // 编辑信息
    editData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      id: 'id',
      rules: {
        authorizedPersonNo: [{ required: true, message: '请选择人员', trigger: 'change' }],
        deadline: [{ required: true, message: '请选择截止时间', trigger: 'change' }],
      },
      addApi: this.$api.timeGrants.add,
      editApi: this.$api.timeGrants.update,
      addMethod: 'post',
      editMethod: 'put',
      depData: [],
      seleterWkNameData: [],
      seleterSuperioerWkNameData: [],
       pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          },
        },
    };
  },
  mounted() {},
  methods: {
    resetSubmitParams(params) {
      const sendParams = {};
      sendParams.id = params.id;
      sendParams.authorizedPersonNo = params.authorizedPersonNo;
      sendParams.deadline = params.deadline;
      sendParams.status = params.status;
      return sendParams;
    },
    resDepData(data) {
      this.depData = data;
    },
    getSelecterWkNameData(data) {
      this.seleterWkNameData = data;
    },

    paramsResetFn(query, pageIndex, pageSize) {
      return { filter: query, PageIndex: pageIndex, PageSize: pageSize };
    },
    formatDataFn(res) {
      const list = [];
      const obj = {};
      res.data &&
        res.data.rows.forEach((t) => {
          const _obj = _.cloneDeep(obj);
          _obj.department = t.department;
          (_obj.jobNo = t.wkNo), (_obj.name = t.wkName);
          list.push(_obj);
        });
      return list;
    },
  },
};
</script>
<style scoped lang="scss">
.user-edit {
  .customerSelect {
    width: 100%;
  }
  .el-date-editor--date {
    width: 100%;
  }
}
</style>
